<form [formGroup]="dashboardKeysForm" novalidate>
    <div class="row">
        <div class="col-md-12">
            <div class="form-group"
                [ngClass]="{ 'has-error': !dashboardKeysForm.controls['dashboardDropdownId'].valid && dashboardKeysForm.controls['dashboardDropdownId'].touched }">
                <label for="tbdescription" class="textBody--xs u-color--gray-10"><strong>Key</strong></label>
                <ul class="mapkey m-0">
                    <li *ngFor="let item of keyDropDownItems" [value]="item?.id" (click)="onKeyItemSelected(item)"
                        [ngClass]="{'active': item?.id == selectedKeyItemId }"><span class="mapkey__key"
                            [ngStyle]="{'background': item?.colour}"></span>{{item?.text}}</li>
                </ul>
                <div *ngIf="dashboardKeysForm.controls['dashboardDropdownId'].hasError('required') && dashboardKeysForm.controls['dashboardDropdownId'].touched"
                    class="alert alert-danger">Category details text is required.</div>
            </div>
        </div>
        <div class="col-md-12">
            <div class="form-group">
                <label for="tbdescription" class="textBody--xs u-color--gray-10"><strong>Location hover
                        text</strong></label>
                <ckeditor formControlName="text" [config]="config" [editor]="Editor" ckEditorEnhanced></ckeditor>
            </div>
        </div>
    </div>
    <div class="card u-marginTop--x-large">
    </div>
</form>
<latestupdatemodal #latestUpdateModal [(latestUpdate)]="updateText" (onLatestUpdateUpdated)="publishContent($event);">
</latestupdatemodal>